import { toast, ToastOptions } from 'react-hot-toast';
import type { ReactNode } from 'react';
import { X, Check, Info } from 'lucide-react';
import React from 'react';

const baseStyles: ToastOptions['style'] = {
  padding: '16px',
  borderRadius: '8px',
  color: '#FFFFFF',
};

interface ToastConfig {
  message: string;
  duration?: number;
  icon?: ReactNode;
  style?: ToastOptions['style'];
}

export const showToast = {
  success: (config: ToastConfig | string) => {
    const options = typeof config === 'string' ? { message: config } : config;
    
    toast.success(options.message, {
      duration: options.duration || 2000,
      style: {
        ...baseStyles,
        background: '#10B981',
        border: '1px solid #059669',
        ...options.style,
      },
      icon: options.icon || '🎉'
    });
  },

  error: (config: ToastConfig | string) => {
    const options = typeof config === 'string' ? { message: config } : config;
    
    toast.error(options.message, {
      duration: options.duration || 1000,
      icon: React.createElement(X, { className: "w-4 h-4" }),
      style: {
        ...baseStyles,
        background: '#EF4444',
        ...options.style,
      },
    });
  },

  info: (config: ToastConfig | string) => {
    const options = typeof config === 'string' ? { message: config } : config;
    
    toast(options.message, {
      duration: options.duration || 1000,
      icon: React.createElement(Info, { className: "w-4 h-4" }),
      style: {
        ...baseStyles,
        background: '#6B7280',
        ...options.style,
      },
    });
  }
}; 